import { defineMessages } from "react-intl";

export default defineMessages({
  ringtwicePlus: {
    id: "advantages.ringtwicePlus",
    defaultMessage: "Ring Twice<plus></plus>",
  },
  subtitleAdvantages: {
    id: "advantages.subtitleAdvantages",
    defaultMessage:
      "Enjoy the full experience and don't worry about anything else.",
  },
  discover: {
    id: "subscribe.discover",
    defaultMessage: "Discover",
  },
  ringtwice_plus_advantage_one_closure: {
    id: "advantages.ringtwice_plus_advantage_one_closure",
    defaultMessage:
      "<bold>0% de frais de gestion</bold> au lieu de 20% sur tous vos services",
  },
  ringtwice_plus_advantage_two_closure: {
    id: "advantages.ringtwice_plus_advantage_two_closure",
    defaultMessage: "<bold>Garantie: Satisfait</bold> ou refait",
  },
  ringtwice_plus_advantage_three_closure: {
    id: "advantages.ringtwice_plus_advantage_three_closure",
    defaultMessage: "Un empêchement ? <bold>Annulez gratuitement</bold>",
  },
  ringtwice_plus_advantage_four_closure: {
    id: "advantages.ringtwice_plus_advantage_four_closure",
    defaultMessage:
      "Un pépin ? Pas de stress, notre <bold>assurance AXA</bold> vous couvre",
  },
});
